import { reactive } from 'vue'
import { getRechargeConfig } from '@/api/modules/recharge'

export const rechargeConfig = reactive({
  pointsPerYuan: 100,
  consumptionRatio: 100,
  loaded: false,
  balanceVersion: 0,
})

export function notifyBalanceChanged() {
  rechargeConfig.balanceVersion++
}

export async function fetchRechargeConfig() {
  try {
    const res = await getRechargeConfig()
    const data = res?.data ?? res
    if (data?.points_per_yuan != null) rechargeConfig.pointsPerYuan = Number(data.points_per_yuan) || 100
    if (data?.consumption_ratio != null) rechargeConfig.consumptionRatio = Number(data.consumption_ratio) || 100
    rechargeConfig.loaded = true
  } catch {
    rechargeConfig.loaded = true
  }
}

export function applyConsumptionRatio(baseCost) {
  if (!baseCost || baseCost <= 0) return 0
  return Math.max(1, Math.ceil(baseCost * rechargeConfig.consumptionRatio / 100))
}
